import { useId } from 'react';

/** Uses the explicit id when given, otherwise a React-generated one (stable across renders). */
export function useStableId(explicit?: string): string {
  const generated = useId();
  return explicit ?? generated;
}

export interface FieldIds {
  inputId: string;
  hintId: string;
  errorId: string;
  /** The id list for `aria-describedby`: the error when present, otherwise the hint, otherwise nothing. */
  describedBy: string | undefined;
}

/** Ids for a labelled form control with optional hint and error text (all derived from one base id). */
export function useFieldIds(
  explicit: string | undefined,
  state: { hint?: boolean | undefined; error?: boolean | undefined },
): FieldIds {
  const inputId = useStableId(explicit);
  const hintId = `${inputId}-hint`;
  const errorId = `${inputId}-error`;
  const describedBy = state.error ? errorId : state.hint ? hintId : undefined;
  return { inputId, hintId, errorId, describedBy };
}
